<template>
  <div>
    <!-- Page content -->
    <section class="py-6">
      <b-container>
          <h2 class="h2 font-weight-900 d-md-none d-block">{{ $t('cooptation.title') }}</h2>
          <b-row align-v="center" class="content-center cooptation shadow">
            <b-col md="6" cols="12" class="pl-md-6 order-md-1 order-2">
              <h2 class="h2 font-weight-900 d-none d-md-block">{{ $t('cooptation.title') }}</h2>
              <p class="mt-md-5" v-html="$t('cooptation.description')">fsfsf</p>
              <div class="pt-md-4 pt-3 text-center text-md-left">
                <b-link :href="data.cooptation.url" target="_blank">
                  <button class="btn btn-success" type="button">{{ $t('cooptation.button') }}</button>
                </b-link>
              </div>
            </b-col>
            <b-col md="6" cols="12" align-v="center" class="order-md-2 order-1 text-center text-md-left">
              <b-link :href="data.cooptation.url" target="_blank">
                <b-img class="" alt="..." :src="cooptImageSource" />
                
              </b-link>
            </b-col>            
          </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import data from '../../../datas';
export default {
  name: 'Cooptation',
  data() {
    return {
      data,
      lang: Vue.i18n.locale(),
      imgFr:'./img/theme/cooptastek-fr.png',
      imgEn:'./img/theme/cooptastek-en.png'
    }
  },
  computed:{
    cooptImageSource(){
        return this.lang=='fr'?this.imgFr:(this.lang=='en'? this.imgEn:this.imgFr);
    }
  }
};
</script>
